import { getImageProps, type ImageProps } from "next/image"
import { computeImageDimensions } from "./computeImageDimensions"
import { optimizeStoryblokImage } from "./optimizeStoryblokImage"
import { parseImageSize } from "./parseImageSize"

type ImagePropsWithSrcString = {
    src: string
} & Omit<ImageProps, "src">

export function getStoryblokImageProps({
    src,
    alt,
    width,
    height,
    ...rest
}: ImagePropsWithSrcString) {
    const optimizedSrc = optimizeStoryblokImage(src)
    const imageDimensions = computeImageDimensions(
        optimizedSrc,
        parseImageSize(width),
        parseImageSize(height)
    )
    const common: Omit<ImageProps, "src" | "width" | "height"> = {
        alt,
        ...rest,
    }
    const { props } = getImageProps({
        src: optimizedSrc,
        width: imageDimensions?.width,
        height: imageDimensions?.height,
        ...common,
    })

    return props
}
